export class AssignChipNumbersRequest {
    constructor(public raceIds?: number[], public chipNumbers?: string, public replaceExisting?: boolean) {
    }
}

